import api from './api'

export const cust = {
  // getAllCusts: () => {
  //   return api.get(`/CloudParkAPI/User/GetAllCustom`)
  // },
  custPageList: (params) => {
    return api.post(`/CloudParkAPI/Cust/CustPageList`, params)
  },
  custMiniProgPageList: (params) => {
    return api.post(`/CloudParkAPI/Cust/CustMiniProgPageList`, params)
  },
  getCustMiniProgData: (params) => {
    return api.post(`/CloudParkAPI/Cust/GetCustMiniProgData`, params)
  },
  custMiniProgSetEdit: (params) => {
    return api.post(`/CloudParkAPI/Cust/CustMiniProgSetEdit`, params)
  },
  custEdit: (params) => {
    return api.post(`/CloudParkAPI/Cust/CustEdit`, params)
  },
  custDelete: (id) => {
    return api.get(`/CloudParkAPI/Cust/CustDelete/${id}`)
  },
  custInfo: (id) => {
    return api.get(`/CloudParkAPI/Cust/CustInfo/${id}`)
  },
  custMaintenanceInfo: (id) => {
    return api.get(`/CloudParkAPI/Cust/CustMaintenanceInfo/${id}`)
  },
  allCustUser: (id) => {
    return api.get(`/CloudParkAPI/Cust/AllCustUser/${id}`)
  },
  groupList: () => {
    return api.get(`/CloudParkAPI/Cust/GroupList`)
  },
  synCust: (id) => {
    return api.get(`/CloudParkAPI/Cust/synCust/${id}`)
  },
  custMaintenanceEdit: (params) => {
    return api.post(`/CloudParkAPI/Cust/custMaintenanceEdit`, params)
  },
  custMaintenanceNewEdit: (params) => {
    return api.post(`/CloudParkAPI/Cust/CustMaintenanceNewEdit`, params)
  },
  custSvrEdit: (params) => {
    return api.post(`/CloudParkAPI/Cust/custSvrEdit`, params)
  },
  allPayType: (params) => {
    return api.post(`/CloudParkAPI/Cust/AllPayType`, params)
  },
  couponAllPayType: (params) => {
    return api.post(`/CloudParkAPI/Cust/CouponAllPayType`, params)
  },
  allCustPayType: (params) => {
    return api.post(`/CloudParkAPI/Cust/AllCustPayType/`, params)
  },
  custPayIPAddrList: () => {
    return api.get(`/CloudParkAPI/Cust/CustPayIPAddrList`)
  },
  getCustGroupByGroup: (params) => {
    return api.post(`/CloudParkAPI/Cust/GetCustGroupByGroup`, params)
  },
  saveCustGroup: (params) => {
    return api.post(`/CloudParkAPI/Cust/SaveCustGroup`, params)
  },
  custGroupList: (params) => {
    return api.post(`/CloudParkAPI/Cust/CustGroupList`, params)
  },
  custGroupDelete: (id) => {
    return api.get(`/CloudParkAPI/Cust/CustGroupDelete/${id}`)
  },
  custKeyPageList: (params) => {
    return api.post(`/CloudParkAPI/Cust/CustKeyPageList`, params)
  },
  custKeyInfo: (id) => {
    return api.get(`/CloudParkAPI/Cust/CustKeyInfo/${id}`)
  },
  custKeyDelete: (id) => {
    return api.get(`/CloudParkAPI/Cust/CustKeyDelete/${id}`)
  },
  custKeyRecovery: (id) => {
    return api.get(`/CloudParkAPI/Cust/CustKeyRecovery/${id}`)
  },
  custKeyEdit: (params) => {
    return api.post(`/CloudParkAPI/Cust/CustKeyEdit`, params)
  },
  getSysInterfaceList: (params) => {
    return api.post(`/CloudParkAPI/Cust/GetSysInterfaceDataAsync`, params)
  },
  saveSysInterface: (params) => {
    return api.post(`/CloudParkAPI/Cust/SaveSysInterfaceAsyn`, params)
  },
  deleteSysInterfaceData: (id) => {
    return api.get(`/CloudParkAPI/Cust/DeleteSysInterfaceDataAsync/${id}`)
  },
  saveApp: (params) => {
    return api.post(`/CloudParkAPI/Cust/SaveAppAsync`, params)
  },
  getAppList: (params) => {
    return api.post(`/CloudParkAPI/Cust/GetAppListAsync`, params)
  },
  deleteApp: (id) => {
    return api.get(`/CloudParkAPI/Cust/DeleteAppAsync/${id}`)
  },
  getAllSysInterfaceData: (params) => {
    return api.post(`/CloudParkAPI/Cust/GetAllSysInterfaceDataAsync`, params)
  },
  saveAppSetting: (params) => {
    return api.post(`/CloudParkAPI/Cust/SaveAppSettingAsync`, params)
  },
  getPayApplication: (params) => {
    return api.post(`/CloudParkAPI/Cust/GetPayApplication`, params)
  },
  gettCouponPayApplication: (params) => {
    return api.post(`/CloudParkAPI/Cust/GettCouponPayApplication`, params)
  }
}



// WEBPACK FOOTER //
// ./src/api/cust.js